




















import {Component, Mixins} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';
import {Inject} from 'inversify-props';

import {Status} from '@/model/Messaging';
import {IAuthService} from '@/services/IAuth.service';

import {AppStore} from '@/store/App.store';
import {ApiStore} from '@/store/Api.store';
import {AuthStore} from '@/store/Auth.store';
import {MessagingStore} from '@/store/Messaging.store';
import {Notify} from '@/utils/Notify';
import {BaseComponent} from '@/mixins/BaseComponent';

@Component
export default class GatewayLimitedBanner extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('MessagingStore'))
  private messagingStore!: MessagingStore;

  @Inject(Symbol.for('IAuthService'))
  private authService!: IAuthService;

  private apiStore: ApiStore = getModule(ApiStore, this.$store);

  @Inject(Symbol.for('AuthStore'))
  private authStore!: AuthStore;

  private appStore: AppStore = getModule(AppStore, this.$store);

  private Status = Status;

  private connecting: boolean = false;

  private async connect() {
    this.connecting = true;

    if (!this.apiStore.Remote || !this.authStore.Token) {
      Notify.Error(this.logger, `Could not connect gateway events`);
      return;
    }

    try {
      await this.messagingStore.connect(this.apiStore.Remote, this.apiStore.Secured, this.authStore.Token);
      Notify.Success(this.logger, `Connected to gateway events`);
    } catch (error) {
      Notify.Error(this.logger, `Could not connect gateway events`, error);
    } finally {
      this.connecting = false;
      this.appStore.setMessagingStatus(this.messagingStore.Status);
    }
  }
}
